import { FieldAttributes } from 'formik';
import React, { useCallback } from 'react';

import { FormikTextField } from 'components';

type Props = FieldAttributes<any>;

export const FormikJsonField: React.FC<Props> = (props) => {
  const handleKeyDown = useCallback((event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  }, []);

  return (
    <FormikTextField multiline rows={10} {...props} onKeyDown={handleKeyDown} />
  );
};
